<template>
  
    <slot></slot>
  <footer class="bg-gray-100">
    <section class="pt-md-32 container-xl border-top">
      <div class="row justify-content-around">
        <ClientOnly>
          <div v-if="width>= breakpoints.screen_mobile" v-for="node in nodes" class="col-6 col-md-3 mb-3">
            <h5>{{ node.label }}</h5>
            <ul class="nav flex-column mt-3">
              <li v-for="child in node.children" :key="child.key"  class="nav-item mb-2">
                <nuxt-link v-if="child.type === 'url'" :to="child.data" class="text-gray-700">
                  {{ child.label }}
                </nuxt-link>
                <div v-else>
                  <div v-if="child.label == 'Déconnexion'" @click="logout" class="signout-btn cursor-pointer">
                    {{ child.label }}
                  </div>
                  <div v-else-if="!route.path.startsWith('/voitures')" @click="contactEmbed.setShowEmbed(!contactEmbed.showEmbed)" class="contact-btn cursor-pointer">
                    {{ child.label }}
                  </div> 
                </div>
              </li>
            </ul>
          </div>
        </ClientOnly>
        <ClientOnly>
          <div v-if="width< breakpoints.screen_mobile" class="mb-footer d-flex flex-wrap px-0">
            
              <Accordion :activeIndex="[0]">
                <AccordionTab v-for="node in nodes" :header="node.label" >
                  <ul>
                    <li v-for="child in node.children" :key="child.key">
                      <nuxt-link v-if="child.type === 'url'" :to="child.data">{{ child.label }}</nuxt-link>
                      <div v-else>
                        <div v-if="child.label == 'Déconnexion'" @click="logout" class="signout-btn cursor-pointer"> 
                          {{ child.label }}
                        </div>
                        <div v-else-if="!route.path.startsWith('/voitures')" @click="contactEmbed.setShowEmbed(!contactEmbed.showEmbed)" class="contact-btn cursor-pointer">
                          {{ child.label }}
                        </div> 
                      </div>
                    </li>
                  </ul>
                </AccordionTab>
              </Accordion>
            

          </div>
        </ClientOnly>
        <div class="col-12 col-md-3 mb-3 d-flex d-md-block flex-column align-items-center">
          <div class="fsz-14 fw-bold text-gray-900">Applications mobiles</div>
          <ul class="nav mt-20 w-100 d-flex flex-row justify-content-center justify-content-md-start gap-2">
            <li class="nav-item mb-2 cursor-pointer">
              <div @click="openModal">
                <img
                  src="~/assets/images/logos/play-store-download.svg"
                  alt="Google Play Store"
                  width="120"
                  height="40"
                />
              </div>
            </li>
            <li class="nav-item mb-2 cursor-pointer">
              <div @click="openModal">
                <img
                  src="~/assets/images/logos/app-store-download.svg"
                  alt="App Store"
                  width="120"
                  height="40"
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="mb-4">
        <h4 class="fsz-12 text-gray-500 mb-1">
          <nuxt-link class="text-primary-600 fw-semibold footer-topauto" to="/">TopAuto.tn</nuxt-link> est la plateforme numéro 1 en Tunisie pour l'achat et la vente de voitures neuves et d'occasion. 
          Retrouvez des milliers d'annonces auto de particuliers et de professionnels : voitures économiques, 4x4, SUV, citadines, berlines, utilitaires et plus encore. 
          Que vous cherchiez une <strong>voiture occasion à Tunis</strong>, une <strong>Peugeot 208 pas chère</strong> ou à <strong>vendre voiture rapidement</strong>, TopAuto est la solution idéale. 
          Nos services sont adaptés aux vendeurs particuliers comme aux <strong>professionnels de l'automobile</strong> grâce à l'espace Pro.
        </h4>
        <h4 class="fsz-12 text-gray-500">
          Parcourez nos annonces par marque (Renault, Kia, Hyundai, Volkswagen, Mercedes...), par région (Tunis, Sfax, Sousse, Nabeul, Gabès...) ou par budget. 
          Publiez votre annonce en quelques clics, suivez sa performance, et utilisez vos crédits pour booster votre visibilité. 
          Avec TopAuto, acheter ou vendre une voiture en Tunisie n'a jamais été aussi simple.
        </h4>
      </div>
  
      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center py-20 border-top copyrights gap-3">
        <div class="d-flex align-items-center justify-content-between gap-3">
          <nuxt-link to="/" aria-label="Retour à l'accueil TopAuto">
            <img
              class="logo-white"
              src="~/assets/images/logos/top-auto-logo-black.svg"
              alt="Logo TopAuto"
            />
            <img
              class="logo-dark"
              src="~/assets/images/logos/LogoTA-Dark.svg"
              alt="Logo TopAuto"
            />
          </nuxt-link>

          <span>© 2025 topauto.tn</span>
        </div>
        <div class="footer-theme-switch position-relative">
          <button
            class="options-button expand d-flex align-items-center gap-2 px-2"
            type="button"
            aria-haspopup="menu"
            :aria-expanded="themeMenuOpen"
            :title="displayThemeLabel"
            @click.stop="themeMenuOpen = !themeMenuOpen"
          >
            <i class="material-symbols-rounded fsz-18">{{ displayThemeIcon }}</i>
            <span class="fsz-12 fw-medium">Theme</span>
          </button>
          <OnClickOutside
            v-if="themeMenuOpen"
            class="dropdowns-panel border border-1 bg-white rounded-3 position-absolute bottom-100 end-0 mb-2"
            style="min-width: 160px; z-index: 1035;"
            @trigger="themeMenuOpen = false"
          >
            <ul class="inner-list m-0">
              <li>
                <a class="options d-flex align-items-center justify-content-between" href="#" @click.prevent="applyTheme('light')">
                  Light
                  <i class="material-symbols-rounded fsz-18">light_mode</i>
                </a>
              </li>
              <li>
                <a class="options d-flex align-items-center justify-content-between" href="#" @click.prevent="applyTheme('dark')">
                  Dark
                  <i class="material-symbols-rounded fsz-18">dark_mode</i>
                </a>
              </li>
              <li>
                <a class="options d-flex align-items-center justify-content-between" href="#" @click.prevent="applyTheme('system')">
                  System
                  <i class="material-symbols-rounded fsz-18">brightness_auto</i>
                </a>
              </li>
            </ul>
          </OnClickOutside>
        </div>
      </div>
    </section>
    <DialogsAppStore 
      :visible="isModalVisible" 
      @close="closeModal" 
      @confirm="handleConfirm"
    />
  </footer>



</template>

<script setup lang="ts">
import { OnClickOutside } from '@vueuse/components';
import { breakpoints } from '~/utils/breakpoints'

type ThemePreference = 'light' | 'dark' | 'system';

const { width } = useWindowSize()

const contactEmbed = useContactEmbed();
const route = useRoute();
const isModalVisible = ref(false);
const cookieId = useCookie("userId");
const cookies = useCookie('userToken');
const isLoggedIn = !!cookieId.value;
const { themePreference, resolvedTheme, setTheme } = useTheme();
const themeMenuOpen = ref(false);
const themeHydrated = ref(false);

const themeIcon = computed(() => {
  if (themePreference.value === 'system') {
    return 'brightness_auto';
  }
  return themePreference.value === 'dark' ? 'dark_mode' : 'light_mode';
});

const themeLabel = computed(() => {
  if (themePreference.value === 'system') {
    return `Theme: System (${resolvedTheme.value})`;
  }
  return `Theme: ${themePreference.value}`;
});

const displayThemeIcon = computed(() =>
  themeHydrated.value ? themeIcon.value : 'brightness_auto'
);
const displayThemeLabel = computed(() =>
  themeHydrated.value ? themeLabel.value : 'Theme: System (light)'
);

const applyTheme = (value: ThemePreference) => {
  setTheme(value);
  themeMenuOpen.value = false;
};

const nodes = ref([
    {
        key: '0',
        label: 'À propos de TopAuto',
        children: [
            { key: '0-0', label: 'Contactez nous', data: '/contactez-nous', type: 'url' },
            { key: '0-1', label: 'Conditions d’utilisation', data: '/conditions-d-utilisation', type: 'url' },
            { key: '0-2', label: 'Politique de Confidentialité', data: '/politique-de-confidentialite', type: 'url' },
        ]
    },
    {
        key: '1',
        label: 'Voitures d’occasion',
        children: [
            { key: '1-0', label: 'Avantages', data: '/vendre-voiture', type: 'url' },
            { key: '1-1', label: 'Annonces auto par marque', data: '/marques-voiture', type: 'url' },
            { key: '1-2', label: 'Annonces auto par région', data: '/region-voiture', type: 'url' }
        ]
    },
    {
    key: '2',
    label: 'Espace Pro',
    children: isLoggedIn
        ? [
            { key: '2-0', label: 'Mon compte', data: '/dashboard/home', type: 'url' },
            { key: '2-1', label: 'Déconnexion', data: '', type: 'button' },
            { key: '2-2', label: 'Contact', data: '', type: 'button' }
          ]
        : [
            { key: '2-0', label: 'Connexion', data: '/authentication/login', type: 'url' },
            { key: '2-1', label: 'Inscription', data: '/authentication/signup', type: 'url' },
            { key: '2-2', label: 'Contact', data: '', type: 'button' }
          ]
    }
]);

const openModal = () => {
  isModalVisible.value = true
};

const closeModal = () => {
  isModalVisible.value = false;
};

const handleConfirm = () => {
  isModalVisible.value = false;
}

const logout = () =>{
try {   
  cookieId.value = null
  cookies.value = null
  reloadNuxtApp({
      path: "/",
      ttl: 1000,
  });
} catch (error) {
    console.error('Erreur de déconnexion:', error)
}
    
}

onMounted(() => {
  themeHydrated.value = true;
});

</script>

<style lang="scss" scoped>

.footer-topauto{
  &:hover{
    color:#0141CC !important;
    text-decoration: underline;
  }
}

</style>
